/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Segment_Event_Group_Option_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Select segmentation option" |
*
* @param {Segment_Event_Group_Option_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const segment_event_group_option_aria_label = /** @type {((inputs?: Segment_Event_Group_Option_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Segment_Event_Group_Option_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Selectionner l'option de segmentation")
	if (locale === "de") return /** @type {LocalizedString} */ ("Segmentierungsoption auswählen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona l'opzione di segmentazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите вариант сегментации")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccionar la opción de segmentación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择分段选项")
	if (locale === "ja") return /** @type {LocalizedString} */ ("セグメンテーションオプションを選択")
	if (locale === "hi") return /** @type {LocalizedString} */ ("विभाजन विकल्प चुनें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione a opção de segmentação")
	return /** @type {LocalizedString} */ ("Select segmentation option")
});